import { useCallback } from 'react';
import { Column, Table } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { getTableColumnPinningProperties } from '../../utils';

export const useTablePinningOptions = () => {
  const { t } = useTranslation();

  const getTablePinningOptions = useCallback(
    <T>(column: Column<T>, table: Table<T>) => {
      const pinnable = column.columnDef.pinnable ?? true;
      if (!pinnable) return [];
      const { isLeftPinned, isRightPinned } = getTableColumnPinningProperties(
        column,
        table
      );

      const options = [
        isLeftPinned
          ? {
              label: t('pinning.unpin'),
              onClick: () => column.pin(false),
            }
          : {
              label: t('pinning.toLeft'),
              onClick: () => column.pin('left'),
            },
        isRightPinned
          ? {
              label: t('pinning.unpin'),
              onClick: () => column.pin(false),
            }
          : {
              label: t('pinning.toRight'),
              onClick: () => column.pin('right'),
            },
      ];

      return options;
    },
    [t]
  );

  return getTablePinningOptions;
};
